import { EnvironmentGroupId } from '@/react/portainer/environments/types';

import { AccessPolicyValue } from '../rbac/types';

/**
 * Stored policy data structure (from backend)
 * This is what comes back from the API in policy.Data
 */
export interface DockerRegistryPolicyData {
  RegistryAccessPolicies: Record<
    // registry ID
    string,
    // user and team ids with access to the registry
    {
      UserAccessPolicies: Record<string, AccessPolicyValue>;
      TeamAccessPolicies: Record<string, AccessPolicyValue>;
    }
  >;
}

/**
 * API payload for Docker Registry Policy
 * Uses PascalCase to match backend expectations
 */
export interface DockerRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    // registry ID
    string,
    // user and team ids with access to the registry
    {
      UserAccessPolicies: Record<string, AccessPolicyValue>;
      TeamAccessPolicies: Record<string, AccessPolicyValue>;
    }
  >;
}

/**
 * Complete form values for Docker Registry Policy form.
 * Combines common policy fields (name, environmentGroupIds) with type-specific fields.
 * This is the type used by Formik in DockerRegistryPolicyForm.
 */
export interface DockerRegistryFormValues {
  /** Policy name */
  name: string;
  /** Environment groups to apply the policy to */
  environmentGroupIds: Array<EnvironmentGroupId>;
  /** Registry access rows - one row per registry with user/team access */
  accessRows: Array<{
    registryId: number;
    userIds: Array<number>;
    teamIds: Array<number>;
  }>;
}

/**
 * Type-specific form data for Docker Registry Policy (without common fields).
 * Used by inner form components.
 */
export interface DockerRegistryFormData {
  accessRows: Array<{
    registryId: number;
    userIds: Array<number>;
    teamIds: Array<number>;
  }>;
}

/**
 * Default initial values for Docker Registry Policy type-specific fields (create mode)
 */
export const DOCKER_REGISTRY_INITIAL_VALUES: DockerRegistryFormData = {
  accessRows: [],
};

/**
 * Default initial values for complete Docker Registry Policy form (create mode)
 */
export const DOCKER_REGISTRY_FORM_INITIAL_VALUES: DockerRegistryFormValues = {
  name: '',
  environmentGroupIds: [],
  ...DOCKER_REGISTRY_INITIAL_VALUES,
};
